import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { PlanningFixed } from '../classes/planningfixed.class';

@Pipe({
    name: 'planningFixedTooltip',
    standalone: false,
})
export class PlanningFixedTooltipPipe implements PipeTransform {
    transform(fixed: PlanningFixed): string {
        if (!fixed) {
            return '';
        }

        const datePipe = new DatePipe('nl');
        const until = fixed.fixeduntil ? ` t/m ${datePipe.transform(fixed.fixeduntil, 'd MMMM yyyy')}` : '';

        return `Vastgezet op ${datePipe.transform(fixed.created_at, 'd MMMM yyyy HH:mm')}${until} door ${fixed.user?.name}`;
    }
}
